var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5168_17178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6 2H4.4C3.76348 2 3.15303 2.25286 2.70294 2.70294C2.25286 3.15303 2 3.76348 2 4.4V31.6C2 32.2365 2.25286 32.847 2.70294 33.2971C3.15303 33.7471 3.76348 34 4.4 34H31.6C32.2365 34 32.847 33.7471 33.2971 33.2971C33.7471 32.847 34 32.2365 34 31.6V4.4C34 3.76348 33.7471 3.15303 33.2971 2.70294C32.847 2.25286 32.2365 2 31.6 2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39844 14.0422C11.0584 10.8422 14.2584 9.24219 17.9984 9.24219C21.7384 9.24219 24.9384 10.8422 27.5984 14.0422",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0016 23.6008C18.6381 23.6008 19.2485 23.3479 19.6986 22.8978C20.1487 22.4478 20.4016 21.8373 20.4016 21.2008C20.4016 20.5643 20.1487 19.9538 19.6986 19.5037C19.2485 19.0536 18.6381 18.8008 18.0016 18.8008C17.365 18.8008 16.7546 19.0536 16.3045 19.5037C15.8544 19.9538 15.6016 20.5643 15.6016 21.2008C15.6016 21.8373 15.8544 22.4478 16.3045 22.8978C16.7546 23.3479 17.365 23.6008 18.0016 23.6008Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.6016L18.0064 21.2016",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5168_17178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.398438 0.398438H35.5984V35.5984H0.398438V0.398438Z",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.5b5cd00a0bab54f9ea19b72a88db9bb2.svg";
export { ForwardRef as ReactComponent };